import dynamic from "next/dynamic";
import PlatformInteractiveExperienceHomepageFirstFoldConfig from "./platform-interactive-experience-homepage-first-fold-config";
import PlatformInteractiveExperienceHomepageFirstFoldAdvancedConfig from "./platform-interactive-experience-homepage-first-fold-advanced-config";
const PlatformInteractiveExperienceHomepageFirstFoldComponent = dynamic(()=>import("./platform-interactive-experience-homepage-first-fold-component"));
export default {
    PlatformInteractiveExperienceHomepageFirstFoldComponent,
    PlatformInteractiveExperienceHomepageFirstFoldConfig,
    PlatformInteractiveExperienceHomepageFirstFoldAdvancedConfig
};
